// extracted by mini-css-extract-plugin
module.exports = {"FeesCalculator":"FeesCalculator_FeesCalculator__ntZIN"};